import React, { useContext, useEffect, useState } from "react";
import "./Login.Styles.scss";
import img from "../svg/logo.svg";
import {
  FacebookLoginButton,
  GoogleLoginButton,
} from "react-social-login-buttons";
import { firebaseContext } from "../contexts/FirebaseContext";
import { useHistory } from "react-router-dom";
import { ROUTES } from "../routes";

export default function LoginScreen() {
  const [error, setError] = useState("");
  const firebase = useContext(firebaseContext);
  const history = useHistory();

  const loginWithFacebook = async () => {
    try {
      const provider = new firebase.auth.FacebookAuthProvider();
      await firebase.auth().signInWithPopup(provider);
    } catch (err) {
      console.log(err);
    }
  };

  const loginWithGoogle = async () => {
    try {
      const provider = new firebase.auth.GoogleAuthProvider();

      await firebase.auth().signInWithPopup(provider);
    } catch (err) {
      console.log(err);
      setError(err.message);
    }
  };

  useEffect(() => {
    firebase.auth().onAuthStateChanged((user) => {
      if (user) {
        history.push(ROUTES.mainScreen);
      }
    });
  }, [firebase, history]);

  return (
    <div>
      <div className="col-xs-10 col-sm-8 col-md-6 login-container col-xs-offset-1 col-sm-offset-2 col-md-offset-3">
        <div className="logo col-xs-8 col-md-4 col-xs-offset-2 col-md-offset-4">
          <img alt="" src={img} />
        </div>
        <div className="login-content">
          <h1>USER LOGIN</h1>
          <div className="button-content">
            <div className="icon-container">
              <FacebookLoginButton
                onClick={loginWithFacebook}
                className="icon"
              />
            </div>
            <div className="icon-container">
              <GoogleLoginButton onClick={loginWithGoogle} className="icon" />
            </div>
          </div>
          <div style={{ color: "#e8232d" }}>{error}</div>
          <p>Please use your facebook or Gmail account to login</p>
        </div>
      </div>
    </div>
  );
}
